"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  KeplerGlSchema: true,
  reducerSchema: true,
  KeplerGLSchemaClass: true,
  CURRENT_VERSION: true,
  VERSIONS: true,
  visStateSchemaV1: true,
  FilterSchemaV0: true,
  LayerSchemaV0: true,
  InteractionSchemaV1: true,
  DimensionFieldSchema: true,
  SplitMapsSchema: true,
  filterPropsV1: true,
  visStateSchema: true,
  layerPropsV1: true,
  layerPropsV0: true,
  effectPropsV1: true,
  datasetSchema: true,
  DatasetSchema: true,
  fieldPropertiesV1: true,
  datasetPropertiesV1: true,
  mapStyleSchema: true,
  MapStyleSchemaV1: true,
  CustomMapStyleSchema: true,
  mapStateSchema: true,
  Schema: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _schemaManager["default"];
  }
});
Object.defineProperty(exports, "KeplerGlSchema", {
  enumerable: true,
  get: function get() {
    return _schemaManager["default"];
  }
});
Object.defineProperty(exports, "reducerSchema", {
  enumerable: true,
  get: function get() {
    return _schemaManager.reducerSchema;
  }
});
Object.defineProperty(exports, "KeplerGLSchemaClass", {
  enumerable: true,
  get: function get() {
    return _schemaManager.KeplerGLSchema;
  }
});
Object.defineProperty(exports, "CURRENT_VERSION", {
  enumerable: true,
  get: function get() {
    return _versions.CURRENT_VERSION;
  }
});
Object.defineProperty(exports, "VERSIONS", {
  enumerable: true,
  get: function get() {
    return _versions.VERSIONS;
  }
});
Object.defineProperty(exports, "visStateSchemaV1", {
  enumerable: true,
  get: function get() {
    return _visStateSchema.visStateSchemaV1;
  }
});
Object.defineProperty(exports, "FilterSchemaV0", {
  enumerable: true,
  get: function get() {
    return _visStateSchema.FilterSchemaV0;
  }
});
Object.defineProperty(exports, "LayerSchemaV0", {
  enumerable: true,
  get: function get() {
    return _visStateSchema.LayerSchemaV0;
  }
});
Object.defineProperty(exports, "InteractionSchemaV1", {
  enumerable: true,
  get: function get() {
    return _visStateSchema.InteractionSchemaV1;
  }
});
Object.defineProperty(exports, "DimensionFieldSchema", {
  enumerable: true,
  get: function get() {
    return _visStateSchema.DimensionFieldSchema;
  }
});
Object.defineProperty(exports, "SplitMapsSchema", {
  enumerable: true,
  get: function get() {
    return _visStateSchema.SplitMapsSchema;
  }
});
Object.defineProperty(exports, "filterPropsV1", {
  enumerable: true,
  get: function get() {
    return _visStateSchema.filterPropsV1;
  }
});
Object.defineProperty(exports, "visStateSchema", {
  enumerable: true,
  get: function get() {
    return _visStateSchema["default"];
  }
});
Object.defineProperty(exports, "layerPropsV1", {
  enumerable: true,
  get: function get() {
    return _visStateSchema.layerPropsV1;
  }
});
Object.defineProperty(exports, "layerPropsV0", {
  enumerable: true,
  get: function get() {
    return _visStateSchema.layerPropsV0;
  }
});
Object.defineProperty(exports, "effectPropsV1", {
  enumerable: true,
  get: function get() {
    return _visStateSchema.effectPropsV1;
  }
});
Object.defineProperty(exports, "datasetSchema", {
  enumerable: true,
  get: function get() {
    return _datasetSchema["default"];
  }
});
Object.defineProperty(exports, "DatasetSchema", {
  enumerable: true,
  get: function get() {
    return _datasetSchema.DatasetSchema;
  }
});
Object.defineProperty(exports, "fieldPropertiesV1", {
  enumerable: true,
  get: function get() {
    return _datasetSchema.fieldPropertiesV1;
  }
});
Object.defineProperty(exports, "datasetPropertiesV1", {
  enumerable: true,
  get: function get() {
    return _datasetSchema.propertiesV1;
  }
});
Object.defineProperty(exports, "mapStyleSchema", {
  enumerable: true,
  get: function get() {
    return _mapStyleSchema["default"];
  }
});
Object.defineProperty(exports, "MapStyleSchemaV1", {
  enumerable: true,
  get: function get() {
    return _mapStyleSchema.MapStyleSchemaV1;
  }
});
Object.defineProperty(exports, "CustomMapStyleSchema", {
  enumerable: true,
  get: function get() {
    return _mapStyleSchema.CustomMapStyleSchema;
  }
});
Object.defineProperty(exports, "mapStateSchema", {
  enumerable: true,
  get: function get() {
    return _mapStateSchema["default"];
  }
});
Object.defineProperty(exports, "Schema", {
  enumerable: true,
  get: function get() {
    return _schema["default"];
  }
});

var _schemaManager = _interopRequireWildcard(require("./schema-manager"));

var _versions = require("./versions");

var _visStateSchema = _interopRequireWildcard(require("./vis-state-schema"));

Object.keys(_visStateSchema).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _visStateSchema[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _visStateSchema[key];
    }
  });
});

var _datasetSchema = _interopRequireWildcard(require("./dataset-schema"));

var _mapStyleSchema = _interopRequireWildcard(require("./map-style-schema"));

var _mapStateSchema = _interopRequireDefault(require("./map-state-schema"));

var _schema = _interopRequireDefault(require("./schema"));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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